import { localStorageUtils } from "./storageUtils";

export type FeatureFlags = {
    isAiSearchEnabled: boolean;
    blankSearchEnabled: boolean;
};

const INDIA_CHANNEL_ID = 1;

/** Maps `cn` query param values to recruiter channel IDs. Extend when new regions use string codes. */
const CHANNEL_PARAM_TO_ID: Record<string, number> = {
    in: INDIA_CHANNEL_ID,
};

export const getChannelIdFromParam = (cnParam: string): number => {
    const normalized = cnParam.trim().toLowerCase();
    if (/^\d+$/.test(normalized)) {
        return Number.parseInt(normalized, 10);
    }
    return CHANNEL_PARAM_TO_ID[normalized] ?? NaN;
};

export const isAiSearchEnabled = (): boolean => {
    if (typeof window === "undefined") return false;

    const enabled = !!localStorageUtils.get("aiSearchEnabled");
    const origin = window.location.origin;
    const validOrigin =
        origin.includes("recruiter.foundit.in") || origin.includes("localhost");

    const cnParam =
        new URLSearchParams(window.location.search).get("cn") || "in";
    return (
        enabled &&
        validOrigin &&
        getChannelIdFromParam(cnParam) === INDIA_CHANNEL_ID
    );
};

const blankSearchEnabled = localStorageUtils.get("blankSearchEnabled");

export const featureFlags: FeatureFlags = {
    get isAiSearchEnabled(): boolean {
        return isAiSearchEnabled();
    },
    blankSearchEnabled: blankSearchEnabled ?? false,
};
